import { useContext } from 'react';
import { quizContext } from '../contexts/QuizContext';

export function useQuiz() {
  const value = useContext(quizContext);
  return value;
}
